module.exports = __webpack_public_path__ + "static/media/IMG_20200206_234356.93542bc2.jpg";